import{getApolloErrorMessages as o}from"@netfront/common-library";const r=r=>{const n=o(r);n.length&&console.error(n.join(","))};export{r as handleApolloError};
//# sourceMappingURL=QuestionSnippet.handlers.js.map
